import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import "./Complaints_Form.css";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import { useState } from "react";
function Complaints_Form({handleClose}) {
 const [success, setSuccess] = useState(false);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);
  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        <div className="row">

          {/* Sample ID */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Sample ID</Form.Label>
              <Form.Control placeholder="Enter Sample ID" />
            </Form.Group>
          </div>

          {/* Customer Name */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Customer Name</Form.Label>
              <Form.Control placeholder="Enter Name" />
            </Form.Group>
          </div>

          {/* Customer ID */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Customer ID</Form.Label>
              <Form.Control placeholder="Customer ID" />
            </Form.Group>
          </div>

          {/* Contact Person Name */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Contact Person Name</Form.Label>
              <Form.Control placeholder="Enter Name" />
            </Form.Group>
          </div>

          {/* Contact No */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>(Contact Person) Contact No.</Form.Label>
              <Form.Control placeholder="Enter Contact No." />
            </Form.Group>
          </div>

          {/* Email */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>(Contact Person) Email</Form.Label>
              <Form.Control placeholder="Enter Email" />
            </Form.Group>
          </div>

          {/* Nature Of Complaint */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Nature Of Complaint</Form.Label>
              <Form.Select>
                <option>Nature Of Complaint</option>
                <option>Deficiency In Service</option>
                <option>Restrictive Trade Practice (RTP)</option>
              </Form.Select>
            </Form.Group>
          </div>

          {/* Remark */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Remark</Form.Label>
              <Form.Control placeholder="Enter Remark" />
            </Form.Group>
          </div>

          {/* Attach Document */}
          <div className="col-md-4">
            <Form.Group className="form_group file_field">
              <Form.Label>Attach Document (Optional)</Form.Label>
              <div className="absolute_fields">
                <Form.Control placeholder="Upload File" disabled />
                <div className="upload_icon_holder">
                  <FontAwesomeIcon icon={faUpload} />
                </div>
              </div>
            </Form.Group>
          </div>

        </div>

        {/* Buttons */}
         <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button type="button" className="permission_btn No_btn">
                  Cancel
                </Button>

                <Button
                  type="button"
                  className="permission_btn Yes_btn"
                  onClick={() => setSuccess(true)}
                >
                  Save
                </Button>
              </>
            )}
          </div>
      </div>
    </section>
  );
}

export default Complaints_Form;
